/* tslint:disable */
/* eslint-disable */
/**
 * ClimatePartner API Calculation Service
 * A Unified API for all ClimatePartner products
 *
 * The version of the OpenAPI document: 1.6.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



export interface VehicleFleetConsumption {
    /**
     * type of fuel
     */
    'fuelType': string;
    /**
     * total fuel consumption
     */
    'fuelConsumption': number;
    /**
     * unit of total fuel consumption. Use kg or kWh for gases (plus l for liquified gas), l for liquids, and kWh for electricity.
     */
    'fuelConsumptionUnit': VehicleFleetConsumptionFuelConsumptionUnitEnum;
    /**
     * country where the vehicle was charged with electricity, if applicable
     */
    'country'?: string;
}

export enum VehicleFleetConsumptionFuelConsumptionUnitEnum {
    L = 'l',
    Kg = 'kg',
    KWh = 'kWh'
}


